import { checkAuthStatus } from './session.js';

const PUBLIC_PAGES = ['/login', '/register', '/forget'];

const DEFAULT_PRIVATE_PAGE = '/dashboard';
const DEFAULT_PUBLIC_PAGE = '/login';

function showAppContent() {
    const loader = document.getElementById('app-loader');
    const app = document.getElementById('app');
    if (loader) {
        loader.style.display = 'none';
    }
    if (app) {
        app.style.opacity = 1;
    }
}

export function initializeApp() {
    const currentPath = window.location.pathname.replace(/\/index\.html$/, '').replace(/\/$/, '') || '/';

    if (currentPath === '/') {
        const { isAuthenticated } = checkAuthStatus();
        window.location.replace(isAuthenticated ? DEFAULT_PRIVATE_PAGE : DEFAULT_PUBLIC_PAGE);
        return;
    }

    const { isAuthenticated } = checkAuthStatus();
    const isPublicPage = PUBLIC_PAGES.includes(currentPath);
    let shouldRedirect = false;

    if (isAuthenticated && isPublicPage) {
        window.location.replace(DEFAULT_PRIVATE_PAGE);
        shouldRedirect = true;
    } else if (!isAuthenticated && !isPublicPage) {
        window.location.replace(DEFAULT_PUBLIC_PAGE);
        shouldRedirect = true;
    }

    if (!shouldRedirect) {
        showAppContent();
    }
}